<template>
  <div>
    <vs-table stripe pagination max-items="5" search :data="users">
      <template slot="header">
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          @click="add"
          >Agregar</vs-button
        >
      </template>
      <template slot="thead">
        <vs-th>Nombre</vs-th>
        <vs-th>Email</vs-th>
        <vs-th>Lenguaje</vs-th>
        <vs-th>Rol</vs-th>
        <vs-th class="grid justify-items-center">
          <div class="text-center">Acciones</div>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.names">
            {{ tr.names || tr.names.toUpperCase() }}
          </vs-td>

          <vs-td :data="tr.email">
            {{ tr.email }}
          </vs-td>

          <vs-td :data="tr.language">
            {{ tr.language }}
          </vs-td>

          <vs-td :data="tr.language">
            {{ tr.name }}
          </vs-td>

          <vs-td class="">
            <div class="grid grid-cols-2 justify-items-center">
              <vs-button
               size="small"
                color="warning"
                type="line"
                @click="edit(tr)"
              >Editar</vs-button>
              <vs-button
               size="small"
                color="primary"
                type="line"
                @click="reset_pass(tr)"
              >Restablecer contraseña</vs-button>
              <!-- <vs-button
                radius
                color="danger"
                type="flat"
                icon-pack="feather"
                icon="icon-trash"
                @click="trash(tr)"
              ></vs-button> -->
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import axios from '@/axios'
export default {
  data() {
    return {};
  },
  computed: {
    users() {
      return this.$store.state.lists.table_user;
    },
  },
  mounted() {
    this.$store.dispatch("lists/getListUser");
  },
  methods: {
    add() {
      let display = {
        table: false,
        add: true,
        edit: false,
      };
      this.$store.commit("user/trash_user");
      this.$emit("screen", display);
    },
    edit(item) {
      this.$store.commit("user/set_id", item.id);
      this.$store.commit("user/set_numberId", item.numberId);
      this.$store.commit("user/com_id", item.com_id);
      this.$store.commit("user/set_name", item.names);
      this.$store.commit("user/set_email", item.email);
      this.$store.commit("user/set_rol", item.role_id);
      let display = {
        table: false,
        add: false,
        edit: true,
      };
      this.$emit("screen", display);
    },
    reset_pass(item){
      let me = this

      Swal.fire({
          icon: 'info',
          title: 'Está seguro de restablecer la contraseña para este usuario?',
          showCancelButton: true,
          confirmButtonColor: '#21409A',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar'
      }).then((result) => {
          if (result.isConfirmed) {
              
            me.$vs.loading()
            axios
            .post(`auth/reset_pass`, item, me.config )
            .then(function (response) {
              if( success.success == 1 ){
                me.$vs.notify({
                  title: "Contraseña reestablecida",
                  text: "Se ha enviado un correo con las nuevas credenciales al usuario seleccionado",
                  color: "success",
                  iconPack: "feather",
                  icon: "icon-check",
                });
              }else{
                me.$vs.notify({
                  title: "Error",
                  text: "hubo un error al reestablecer la contraseña",
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-alert-triangle",
                });
              }

                me.$vs.loading.close()
            })
            .catch(function (error) {
                me.$vs.loading.close()
            })
          }
      });
    },
    trash(item) {
      console.log(item);
    },
  },
};
</script>
